import { render } from "./TermsServiceBanner.vue?vue&type=template&id=638cfc2c"
import script from "./TermsServiceBanner.vue?vue&type=script&lang=js"
export * from "./TermsServiceBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__